import { faBangladeshiTakaSign, faBowlFood, faFireAlt, faLeaf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ItemsData } from '../../Data/ItemsData';

const DrinksMenu = () => {
    const navigate = useNavigate();
    const Drinks = ItemsData?.filter(data => data?.category === "Drinks");
    return (
        <div className="container py-10 px-5 md:px-7 w-full">
            <div className="flex flex-col md:flex-row justify-between items-center gap-3 px-5 pb-5">
                <div className="">
                    <h1 className="text-3xl md:text-6xl font-bold fw-bold capitalize" style={{ fontFamily: "Rajdhani" }}>Drinks</h1>
                    <p className="pb-4 pt-2">Consectetur numquam poro nemo veniam
                        eligendi rem adipisci quo modi.</p>
                </div>
            </div>
            <div className='w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mx-auto'>
                {
                    Drinks?.map(data => (
                        <div key={data?.name} className="w-full mx-auto group duration-200">
                            <div className="w-full h-[60%] relative overflow-hidden">
                                <div className="absolute top-1 right-1 z-10">
                                    {data?.badge === "Vegan" && <h3 className="text-md font-sans bg-green-500 px-2"> <FontAwesomeIcon icon={faLeaf} /> {data?.badge}</h3>}
                                    {data?.badge === "Hot" && <h3 className="text-md font-sans bg-red-500 px-2"> <FontAwesomeIcon icon={faFireAlt} /> {data?.badge}</h3>}
                                    {data?.badge === "Non Veg" && <h3 className="text-md font-sans bg-yellow-500 px-2"> <FontAwesomeIcon icon={faBowlFood} /> {data?.badge}</h3>}
                                </div>
                                <img src={data?.img} alt="" className="w-full h-full object-cover group-hover:scale-110 duration-200 " />
                            </div>
                            <div className="space-y-2">
                                <div className="flex justify-between bg-gray-200 items-center gap-2 pl-2">
                                    <h1 className="font-bold text-md">{data?.name}</h1>
                                    <h1 className="font-bold text-xl p-4 bg-[#F5C332]"><FontAwesomeIcon icon={faBangladeshiTakaSign} /> {data?.price}</h1>
                                </div>
                                <p className="text-sm text-justify">{data?.desc.slice(0, 120)}</p>
                                <p className='flex items-center justify-between gap-2'>
                                    <div className="flex items-center gap-2">
                                        <div className="rating">
                                            {

                                                Math.ceil(data?.rating?.total_rating / data?.rating?.total_people) === 1 &&
                                                <div className="rating">
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" checked />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                </div>

                                            }
                                            {

                                                Math.ceil(data?.rating?.total_rating / data?.rating?.total_people) === 2 &&
                                                <div className="rating">
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" checked />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                </div>

                                            }
                                            {

                                                Math.ceil(data?.rating?.total_rating / data?.rating?.total_people) === 3 &&
                                                <div className="rating">
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" checked />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                </div>

                                            }
                                            {

                                                Math.ceil(data?.rating?.total_rating / data?.rating?.total_people) === 4 &&
                                                <div className="rating">
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" checked />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-gray-300" />
                                                </div>

                                            }
                                            {

                                                Math.ceil(data?.rating?.total_rating / data?.rating?.total_people) === 5 &&
                                                <div className="rating">
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" />
                                                    <input name="rating-1" className="mask mask-star w-4 md:w-4  bg-yellow-500" checked />
                                                </div>

                                            }
                                        </div>
                                    </div>

                                </p>
                            </div>
                            <div className="">
                                <button onClick={() => navigate(`/checkout/${data?.id}`)} className='text-xl w-full font-semibold bg-[#F5C332] px-4 py-2'>Buy Now</button>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default DrinksMenu;